import React from 'react';
import { string } from 'prop-types';
import GiftingBlockBase from '../GiftingBlockBase';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { EN_US } from '../../../../utils/constants/LanguageRegionCode';

const {
  strings: {
    GIFT_FLOW: { GIVE_THE_GIFT },
    HOME_PAGE: {
      GENERIC_GIFTING_BLOCK: { GIFT_PRO, WHETHER_YOURE_CELEBRATING }
    }
  }
} = StringConstantsMixin;

const GenericGiftingBlock = ({ languageRegionCode }) => {
  const shortRegionCode = languageRegionCode.split('-')[0];

  return (
    <GiftingBlockBase
      imgSrc={`https://cdn-assets.alltrails.com/assets/images/gifting/generic_gift_cards_${shortRegionCode}.png`}
      title={GIVE_THE_GIFT}
      subtext={WHETHER_YOURE_CELEBRATING}
      ctaText={GIFT_PRO}
      ctaLink={LanguageSupportUtil.wrapUrlSafe('/gift?ref=homepage_gift_genericgiftingblock', languageRegionCode)}
    />
  );
};

GenericGiftingBlock.propTypes = {
  languageRegionCode: string
};

GenericGiftingBlock.defaultProps = {
  languageRegionCode: EN_US
};

export default GenericGiftingBlock;
